import {Directive, ElementRef, Renderer2} from '@angular/core';

/**
 * Generated class for the SlideItemDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[always-square]' // Attribute selector
})
export class AlwaysSquareDirective {

  constructor(public element: ElementRef, public renderer: Renderer2) {
  }

  ngOnInit() {
    this.renderer.setAttribute(this.element.nativeElement, "style", 'width: ' + String(this.element.nativeElement.offsetHeight) + 'px');
  }
}



// WEBPACK FOOTER //
// ./src/directives/always-square/always-square.ts